import CommonConstants from "../../../../../common/constants";
import { IDeleteFuncionarioTreinamentosLoteUseCase } from "../../../presentation/useCases/delete/delete_funcionario_treinamentos_lote_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteFuncionarioTreinamentosLoteUseCase,
 */

export class DeleteFuncionarioTreinamentosLoteUseCase implements IDeleteFuncionarioTreinamentosLoteUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteFuncionarioTreinamentosLote(
    idFuncionario: number,
    idFuncionarioTreinamentosLote: number[],
    originScreen?: number,
  ): Promise<void> {
    await this.repository.deleteFuncionarioTreinamentosLote(
      idFuncionario,
      idFuncionarioTreinamentosLote,
      originScreen ?? CommonConstants.avaliarTreinamentoScreen.FuncionarioCadastro,
    );
  }
}